var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaFeaturedIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-featured-icon1_svg__a",
    d: "M0 70h77.925V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.762 27.736c0 15.318-12.418 27.736-27.736 27.736-15.318 0-27.736-12.418-27.736-27.736C5.29 12.418 17.708 0 33.026 0c15.318 0 27.736 12.418 27.736 27.736",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-featured-icon1_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-featured-icon1_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M26.415 47.547h50.189v-35.66H26.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M1.32 58.113h50.19v-35.66H1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#020303",
    strokeWidth: 2,
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M67.358 47.547h9.246v-35.66H26.415v6.604"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#020303",
    strokeWidth: 2,
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M51.51 29.057v-6.604H1.32v35.66h9.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M14.528 68.68h48.868V33.018H14.528z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#020303",
    strokeWidth: 2,
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M14.528 68.68h48.868V33.018H14.528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.472 43.585a3.962 3.962 0 11-7.924 0 3.962 3.962 0 017.924 0",
    fill: "#E8E9EA",
    mask: "url(#ea-featured-icon1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.472 43.585a3.962 3.962 0 11-7.924 0 3.962 3.962 0 017.924 0z",
    stroke: "#020303",
    strokeWidth: 2,
    mask: "url(#ea-featured-icon1_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M46.226 52.83l-4.622 4.623-9.906-9.906-17.17 17.17v3.962h47.547z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#020303",
    strokeWidth: 2,
    mask: "url(#ea-featured-icon1_svg__b)",
    d: "M46.226 62.075L31.698 47.547l-17.17 17.17v3.962h47.547L46.226 52.83l-3.962 3.962"
  }))));
}
export default SvgEaFeaturedIcon1;